<template>
  <transition name="move-fade" appear="">
    <h2>VideoClips</h2>
  </transition>
  <div class="video-cards-list load-hidden">
    <VideoCard
      v-for="video in videos"
      :key="video.url"
      :video="video"
      :autoplay="calcAutoplay(video.id)"
    />
  </div>
</template>

<script>
import VideosRaw from '@/assets/data/videos.json';
import VideoCard from './VideoCard.vue';
import ScrollReveal from 'scrollreveal';

export default {
  name: 'VideoGallery',
  components: {
    VideoCard,
  },
  props: {
    highlightVideo: String,
  },
  data() {
    return {
      videos: [],
    };
  },
  methods: {
    calcAutoplay(id) {
      if (this.highlightVideo == id) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const sr = ScrollReveal({
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          easing: 'ease-out',
          cleanup: true,
          scale: 0.95,
        });

        sr.reveal('.video-cards-list > *', {
          interval: 50,
        });
      }, 100);
    });

    this.videos = VideosRaw.map((video) => ({
      ...video,
    })).sort((a, b) => b.id - a.id);
  },
  beforeUnmount() {
    ScrollReveal().destroy();
  },
};
</script>

<style scoped>
h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  margin-top: 0;
}

.video-cards-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 3rem;
  padding-top: 0;
}

/* Move + Fade Transition */
.move-fade-enter-active,
.move-fade-leave-active {
  transition: all 0.45s ease;
}

.move-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.move-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.move-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.move-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
